import {ObjectId} from 'types/object-id';

export default <T extends {id: ObjectId}>(dict?: Record<ObjectId, T>): T[] => {
  if (!dict) {
    return [];
  }
  return Object.values(dict);
};
